// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1c7zd","label":"LabeledBox_label__2jzQy"};